export default __webpack_public_path__ + "static/media/header-confirm.35be7f88.svg";